import GridOnIcon from "@mui/icons-material/GridOn";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import AddFeedEventIcon from "common/icons/AddFeedEventIcon";
import AddFeedPurchaseIcon from "common/icons/AddFeedPurchaseIcon";
import FertilizerEventIcon from "common/icons/FertilizerEventIcon";
import FieldPreparationEventIcon from "common/icons/FieldPreparationEventIcon";
import YieldEventIcon from "common/icons/YieldEventIcon";

interface AddNewEventMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onEventTypeClick: (eventType: string) => void;
  addBottomOffset?: boolean; // If true, adds bottom margin for mobile bottom navigation
}

export default function AddNewEventMenu({
  anchorEl,
  open,
  onClose,
  onEventTypeClick,
  addBottomOffset = false,
}: AddNewEventMenuProps) {
  // Calculate bottom offset: BottomTabNavigation minHeight (70px) + safe area inset + extra spacing
  const bottomOffset = addBottomOffset
    ? "calc(15px + env(safe-area-inset-bottom) )"
    : undefined;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      sx={
        bottomOffset
          ? {
              "& .MuiPaper-root": {
                marginBottom: bottomOffset,
                maxHeight: `calc(100vh - ${bottomOffset} - 16px)`,
                overflowY: "auto",
                transform: `translateY(calc(-1 * ${bottomOffset})) !important`,
              },
            }
          : undefined
      }
      PaperProps={{
        sx: {
          backgroundColor: "#ffffff",
          border: "1px solid #e4e4e7",
          borderRadius: "6px",
          minWidth: "200px",
          mt: 1,
        },
      }}
    >
      <Box sx={{ px: 1.5, py: 0.75 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "24px",
            color: "#09090b",
          }}
        >
          Add new event
        </Typography>
      </Box>
      <Divider sx={{ my: 0.5 }} />
      <MenuItem
        onClick={() => onEventTypeClick("reseed")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <LocalFloristIcon sx={{ width: 20, height: 20, color: "#71717a" }} />
        Re-seeding
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("feed")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <AddFeedEventIcon htmlColor="#71717a" sx={{ width: 20, height: 20 }} />
        Feed
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("yield")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <YieldEventIcon htmlColor="#71717a" sx={{ width: 20, height: 20 }} />
        Yields & Harvest
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("fertilizer")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <FertilizerEventIcon
          htmlColor="#71717a"
          sx={{ width: 20, height: 20 }}
        />
        Fertiliser
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("fieldPreparation")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <FieldPreparationEventIcon
          htmlColor="#71717a"
          sx={{ width: 20, height: 20 }}
        />
        Field preparation
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("cover")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <GridOnIcon sx={{ width: 20, height: 20, color: "#71717a" }} />
        Cover
      </MenuItem>
      <MenuItem
        onClick={() => onEventTypeClick("feedPurchase")}
        sx={{
          px: 1.5,
          py: 0.75,
          gap: 1,
          fontSize: "16px",
          lineHeight: "24px",
          color: "#09090b",
        }}
      >
        <AddFeedPurchaseIcon
          htmlColor="#71717a"
          sx={{ width: 20, height: 20 }}
        />
        Feed purchase
      </MenuItem>
    </Menu>
  );
}
